import type { BrandName } from "../brand-names";
import type { HubTheme } from "../hub-theme.types";
import { novaHubTheme } from "./nova";
import { fitupHubTheme } from "./fitup";
import { stageHubTheme } from "./stage";

/**
 * Profile-hub tokens for every brand.
 *
 * Typed as `Record<BrandName, HubTheme>` on purpose: adding a name to
 * `BRAND_NAMES` without adding a hub theme here is a compile error. It used to
 * be `Record<string, HubTheme>` with a `?? NOVA` fallback, which let `stage`
 * silently render Nova's dark theme.
 *
 * `vite.config.ts` imports this map at build time to paint `pageBackground`
 * before the bundle loads — keep this file and its imports dependency-free.
 */
export const HUB_THEMES: Record<BrandName, HubTheme> = {
  nova: novaHubTheme,
  fitup: fitupHubTheme,
  stage: stageHubTheme,
};
